import './Home.css';
import React from "react";
import { Link } from 'react-router-dom'; // 👈 Asegurate de tener esto importado
import Home1 from '../assets/Home/home1.png';
import Home2 from '../assets/Home/home2.png';
import Home3 from '../assets/Home/home3.png';
import Home4 from '../assets/Home/home4.png';
import Home5 from '../assets/Home/home5.png';
import Home6 from '../assets/Home/home6.png';
import Home7 from '../assets/Home/home7.png';
import Home8 from '../assets/Home/home8.png';
import Home9 from '../assets/Home/home9.png';
import Home10 from '../assets/Home/home10.png';
import WhatsappVerde from '../assets/Home/whatsappVerde.png'
import silandechina from '../assets/Home/silandechina1.png';
import silande from '../assets/Footer/silandeLogo.png';

function Home() {
    const sections = [
        { image: Home1, title: "NUESTRA INVESTIGACIÓN SURGE DE SUS NECESIDADES", button: "VER MÁS" },
        { image: Home2, title: "PRODUCTOS CON ALTO CONTENIDO TÉCNICO", description: "Los productos de la compañia cubren un amplio espectro, incluyendo polifulfuro, silicona, butilo, epoxy, poliuretano y recubrimientos. Se han aplicado ampliamente en la construcción de muros cortina, anticorrosión, automóviles, módulos fotovoltáicos de energía solar, LED y para fines militares.", button: "VER CATÁLOGO" },
        { image: Home3, title: "AMPLIO ALCANCE DE MERCADO" },
        { image: Home4, title: "ENFOQUE Y SERVICIO PROFESIONAL", description: " Destacada con un sistema de gestión avanzado, la empresa ha aprobado el sistema de gestión de calificaciones ISO9001 y TS16949 y el certificado del sistema medioambiental ISO14001" },
    ];

    const gridImages = [
        { image: Home5, title: "ARQUITECTURA" },
        { image: Home6, title: "ANTICORROSIÓN" },
        { image: Home7, title: "ELECTRÓNICA" },
        { image: Home8, title: "AUTOMÓVILES" },
        { image: Home9, title: "AEROPUERTOS" },
        { image: Home10, title: "ENERGÍA SOLAR" },
    ];

    return (
        <div className="home-container">
            {sections.map((section, index) => (
                <div
                    key={index}
                    className="home-section"
                    style={{ backgroundImage: `url(${section.image})` }}
                >
                    {index === 0 && (
                        <img src={silande} alt="Silande China" className="silande-china-img" />
                    )}
                    <div className={`home-overlay ${section.button ? '' : 'no-background'}`}>
                        <h2 className='titleHome'>{section.title}</h2>
                        <p className='descriptionHome'>{section.description}</p>

                        {/* 👇 Redireccionar los botones según texto */}
                        {section.button && (
                            <Link to={
                                section.button === "VER MÁS"
                                    ? "/nosotros"
                                    : section.button === "VER CATÁLOGO"
                                        ? "/productos"
                                        : "#"
                            }>
                                <button>{section.button}</button>
                            </Link>
                        )}

                        {index === 2 && (
                            <div className="image-grid">
                                <div className="row">
                                    {gridImages.slice(0, 3).map((img, i) => (
                                        <div key={i} className="col">
                                            <div className="grid-item">
                                                <img src={img.image} alt={img.title} className="grid-img" />
                                                <p className="img-title">{img.title}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="row">
                                    {gridImages.slice(3, 6).map((img, i) => (
                                        <div key={i} className="col">
                                            <div className="grid-item">
                                                <img src={img.image} alt={img.title} className="grid-img" />
                                                <p className="img-title">{img.title}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            ))}
            <button
                className="whatsapp-button"
                onClick={() => window.open("https://wa.me/+5491151489606", "_blank")}
            >
                <img src={WhatsappVerde} alt="WhatsApp" />
            </button>
        </div>
    );
}

export default Home;
